module.exports = __webpack_public_path__ + "img/casper.9ede7024.png";